







































































import Vue from 'vue';
import moment from 'moment';
import { numeric, required, maxLength } from 'vuelidate/lib/validators';
import {
  date,
  dateHelpers,
  exactLength,
  lengthRange,
} from '@/validations';
import { dateFormat } from '@/constants';
import InputMaskTypes from '@/directives/input-mask/input-mask-types';
import { DatePicker } from '@/components/form-components';
import {
  DateFormat,
  FormValidation,
  CloseStepperWrapper,
  DOBAllowedDates,
} from '@/mixins';
import {
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { ExtendMixins } from '@/services';
import { RegistrationIdentityFormModel, StepperSteps } from '@/@types/member';

declare var grecaptcha: any;

interface Data {
  captchaSiteKey: string;
}

export default ExtendMixins(
  DateFormat,
  FormValidation,
  DOBAllowedDates,
  CloseStepperWrapper,
).extend({
  name: 'RegisterStep2',
  props: {
    formModel: {
      type: Object as () => RegistrationIdentityFormModel,
      required: true,
    },
    step: {
      type: Object as () => StepperSteps,
      required: true,
    },
    brand: {
      type: String,
      required: true,
    },
  },
  validations: {
    formModel: {
      dateOfBirth: {
        required,
        date,
        dateOfBirth(value): boolean {
          return dateHelpers.sameOrBeforeDate(moment().format(dateFormat))(
            value,
          );
        },
      },
      last4SSN: {
        exactLength: exactLength(4),
        numeric,
        required,
      },
    },
  },
  data(): Data {
    return {
      captchaSiteKey : process.env.VUE_APP_CAPTCHA_SITE_KEY,
    };
  },
  computed: {
    dateOfBirthErrors(): string[] {
      const formField = 'formModel.dateOfBirth';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'register-step-2-DOB-error-required',
            'global_form-error_dob_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          [
            'register-step-2-DOB-error-invalid-date',
            'global_form-error_default_invalid-format',
          ],
          'date',
        ),
        this.FormValidationMixin.validateField(
          formField,
          'register-step-2-DOB-error-future-date',
          'dateOfBirth',
        ),
      ]);
    },
    last4SSNErrors(): string[] {
      const formField = 'formModel.last4SSN';
      return this.FormValidationMixin.constructErrors(formField, [
        this.FormValidationMixin.validateField(
          formField,
          [
            'register-step-2-SSN-error',
            'global_form-error_ssn-last-4_required',
            'global_form-error_default_required',
          ],
          'required',
        ),
        this.FormValidationMixin.validateField(
          formField,
          ['register-step-2-SSN-error'],
          'exactLength',
          { key: 'exactLength', val: 'length' },
        ),
        this.FormValidationMixin.validateField(
          formField,
          ['register-step-2-SSN-error'],
          'numeric',
        ),
      ]);
    },
    brandPhone(): string {
      return this.$options.filters.t(`register-page-help-phone-${this.brand}`) ;
    },
  },
  mounted(): void {
    window.submit = this.submit.bind(this);
    this.renderReCaptcha();
  },
  components: {
    DatePicker,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
  methods: {
    onSubmit(captchaToken): void {
      grecaptcha.execute();
    },
    submit(captchaToken): void {
      this.$emit('submitRegistrationIdentity', captchaToken);
    },
    previousStep(): void {
      this.$emit('previousStep');
    },
    deconstructDOB(): void {
      this.formModel.dateOfBirth = InputMaskTypes.date.deconstruct(
        this.formModel.dateOfBirth,
      );
    },
    updateDateOfBirth(dateOfBirth): void {
      this.formModel.dateOfBirth = this.formatDate(dateOfBirth);
      this.triggerBlur('formModel.dateOfBirth');
      this.updateHasChanged();
    },
    refreshAction(): void {
      this.step.isError = false;
      this.renderReCaptcha();
    },
    doneAction(): void {
      this.$router.push('login');
    },
    renderReCaptcha(): void {
      setTimeout(() => {
        grecaptcha.render('registrationCaptcha', {
          'sitekey' : this.captchaSiteKey,
          'size': 'invisible',
          'callback' : 'submit',
        });
      }, 1000);
    },
  },
});
